import ParchmentLayout from './audience/components/ParchmentLayout';
import OrnamentSeparator from './audience/components/OrnamentSeparator';

function LandingPage() {
  return (
    <ParchmentLayout className="flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="parchment-card p-8">
          <div className="text-center mb-6">
            <img src="/images/dw_logo.png" alt="Dungeon World - The Show" className="mx-auto w-48 mb-1" />
            <p className="text-ink-light font-body italic text-xl">
              Avventura teatrale interattiva
            </p>
          </div>

          <OrnamentSeparator />

          <div className="text-center space-y-4 my-6">
            <p className="text-ink font-heading text-lg">
              Per partecipare allo show è necessario utilizzare il <strong>QR Code</strong>.
            </p>
            <p className="text-ink-light font-body text-base leading-relaxed">
              Se non ce l'hai, alza la mano e chiama aiuto, poi fai un tiro di <strong>Carisma</strong>.
            </p>
            <p className="text-ink-light font-body text-base leading-relaxed">
              Con <strong>9+</strong> attiri l'attenzione dello staff.
            </p>
          </div>

          <OrnamentSeparator />
        </div>
      </div>
    </ParchmentLayout>
  );
}

export default LandingPage;
